import FsLightbox from "fslightbox-react";
import { useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import KYouthProgrammeDetails from "../../pages/detailspages/KYouthProgrammeDetails";

const KYouthProgramme2 = () => {
  const [toggler, setToggler] = useState(false);
  const videoLink = ["https://www.youtube.com/watch?v=pNje3bWz7V8"];
  return (
    <>
      <div
        // id="faq"
        className="edu-workshop-area workshop-style-1"
      >
        <div className="container eduvibe-animated-shape">
          <div className="row g-5">
            {/* <div className="col-lg-6 order-2 order-lg-1"> */}
            <div className="col-lg-6 order-2 order-lg-1">
              <div
                className="workshop-inner"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "3rem",
                }}
              >
                <KYouthProgrammeDetails />

                <ScrollAnimation
                  animateIn="fadeInUp"
                  animateOut="fadeInOut"
                  className="read-more-btn"
                  animateOnce={true}
                >
                  <a
                    className="edu-btn btn-purple"
                    href="https://kyouthcompany.pepperlabs.my"
                    target="_blank"
                  >
                    INQUIRE NOW
                    <i className="icon-arrow-right-line-right"></i>
                  </a>
                </ScrollAnimation>
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="thumbnail" style={{ padding: "0 !important" }}>
                {/* <img
                  className="radius-small w-100"
                  src={`${process.env.PUBLIC_URL}/k-youth/assets/programme-image.jpg`}
                  alt="Video PopUp Thumb"
                /> */}
                <img
                  className="radius-small w-100"
                  style={{ height: 350, objectFit: "cover" }}
                  src={`${process.env.PUBLIC_URL}/k-youth/assets/mutiracial-stock-2.jpg`}
                  alt="Video PopUp Thumb"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FsLightbox
        toggler={toggler}
        sources={videoLink}
        maxYoutubeVideoDimensions={{ width: 900, height: 550 }}
      />
    </>
  );
};

export default KYouthProgramme2;
